import SelectControlMobile from './component'

export default SelectControlMobile
